import { frontendURL } from 'dashboard/helper/URLHelper';
import AdminCrmmView from './AdminCrmmView.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/admin-crmm'),
    name: 'admin_crmm_index',
    component: AdminCrmmView,
    meta: {
      permissions: ['administrator'],
    },
  },
];
